import React from 'react';

import LabelCDS from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS';
import { LabelVariant } from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import { AutomaticFeeChangeLabel } from 'constants/pendingChanges';

import { AutomaticFeeChangeTagTestIds } from './AutomaticFeeChangeTag.testIds';

// Says what the recalculation did to a fee (on the Fees page and in the save summary); whether it needs a CIC reason
// is decided on save.
const AutomaticFeeChangeTag = ({ pendingChangesActionType = null }) => {
  const label = AutomaticFeeChangeLabel[pendingChangesActionType];

  if (!label) {
    return null;
  }

  return (
    <LabelCDS
      withBorder
      dataTestId={AutomaticFeeChangeTagTestIds.TAG}
      size="S"
      title={label}
      variant={LabelVariant.BLUE}
    />
  );
};

AutomaticFeeChangeTag.propTypes = {
  pendingChangesActionType: PropTypes.string,
};

export default AutomaticFeeChangeTag;
